import { Meeting, MeetingRole } from "@platform/types/platform.types";

export function getUserMeetingRoleFromMeeting(
  meeting: Meeting,
  userId: number | null
): MeetingRole | null {
  if (!meeting) return null;
  if (!meeting.participants) return null;
  if (!userId) return null;

  const role =
    meeting.participants?.find((participant) => participant.user.id === userId)
      ?.role || null;

  if (role) return role;

  return null;
}

export default getUserMeetingRoleFromMeeting;

